import { WbLink } from '../WbLink';
import { makeStyles } from '@material-ui/core';

type Props = {
  value: string;
  href: string;
  hrefTarget?: string;
  showTooltip?: boolean;
};

// TODO: should this be moved to WbLink ?
const useStyles = makeStyles(() => ({
  ellipsis: {
    display: 'block',
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
}));

export const LinkWrapper = ({
  value,
  href,
  hrefTarget,
  showTooltip,
}: Props) => {
  const classes = useStyles();

  return (
    <WbLink
      route={href}
      hrefTarget={href.startsWith('http') ? hrefTarget : undefined}
      externalLink={
        href.startsWith('http') || href.startsWith('mailto') ? href : undefined
      }
      className={classes.ellipsis}
      underlineLink="hover"
      text={value}
      showTooltip={showTooltip}
    />
  );
};
